import { createNotification } from "react-redux-notify";
import { select, put, takeLatest, all } from "redux-saga/effects";

import api from "../../Environment";
import {
  sendTipStripeFailure,
  sendTipStripeSuccess,
  sendTipWalletFailure,
  sendTipWalletSuccess,
  sendTipPaypalSuccess,
  sendTipPaypalFailure,
  sendStreamingTipWalletSuccess,
  sendStreamingTipWalletFailure,
} from "../actions/SendTipAction";
import {
  SEND_TIP_BY_STRIPE_START,
  SEND_TIP_BY_WALLET_START,
  SEND_TIP_BY_PAYPAL_START,
  SEND_STREAMING_TIP_BY_WALLET_START,
} from "../actions/ActionConstant";
import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage
} from "../../components/helper/NotificationMessage";
import ErrorUtils from "../../helpers/utils/errors";
import { closeModal } from "../../store/actions/ModalAction";
import { showErrorComponent } from "../../store/actions/ComponentAction";
import { fetchWalletDetailsStart } from "../actions/WalletAction";
import { incrementPostTipCount } from "../../store/actions/HomeAction";
import { incrementSinglePostTipsCount } from "../../store/actions/PostAction";

function* sendTipStripeAPI() {
  try {
    const inputData = yield select((state) => state.tip.tipStripe.inputData);
    const response = yield api.postMethod("tips_payment_by_stripe", inputData);
    if (response.data.success) {
      yield put(sendTipStripeSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(sendTipStripeFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(sendTipStripeFailure(error));
    const { notify, message } = ErrorUtils.handleApiException(error)
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* sendTipPaypalAPI() {
  try {
    const inputData = yield select((state) => state.tip.tipPaypal.inputData);
    const response = yield api.postMethod("tips_payment_by_paypal", inputData);
    if (response.data.success) {
      yield put(sendTipPaypalSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(sendTipPaypalFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(sendTipPaypalFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const { notify, message } = ErrorUtils.handleApiException(error)
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* sendTipWalletAPI() {
  try {
    const inputData = yield select((state) => state.tip.tipWallet.inputData);
    const response = yield api.postAuthMethod("tips_payment_by_wallet", inputData);
    if (response.data.success) {
      yield put(sendTipWalletSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(closeModal());
      yield put(createNotification(notificationMessage));
      yield put(fetchWalletDetailsStart());
      yield put(incrementSinglePostTipsCount());
      yield put(incrementPostTipCount(inputData.post_id));
    } else {
      yield put(sendTipWalletFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(sendTipWalletFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const { notify, message } = ErrorUtils.handleApiException(error)
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* sendStreamingTipWalletAPI() {
  try {
    const inputData = yield select(
      (state) => state.tip.streamingTipWallet.inputData
    );
    const { onSuccess, ...other } = inputData
    const response = yield api.postAuthMethod(
      "streaming_channel_tips_payment_by_wallet",
      other
    );
    if (response.data.success) {
      yield put(sendStreamingTipWalletSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      yield put(fetchWalletDetailsStart());

      onSuccess(response.data)
    } else {
      yield put(sendTipWalletFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(sendStreamingTipWalletFailure(error));
    const { notify, message } = ErrorUtils.handleApiException(error)
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(SEND_TIP_BY_STRIPE_START, sendTipStripeAPI)]);
  yield all([yield takeLatest(SEND_TIP_BY_WALLET_START, sendTipWalletAPI)]);
  yield all([yield takeLatest(SEND_TIP_BY_PAYPAL_START, sendTipPaypalAPI)]);
  yield all([
    yield takeLatest(
      SEND_STREAMING_TIP_BY_WALLET_START,
      sendStreamingTipWalletAPI
    ),
  ]);
}
